export default "__VITE_ASSET__DZs3UQrC__"